import React from 'react';
import { Image } from 'components/ui';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import { wrapFunctionalComponent } from 'utils/framework';

const { getLocaleResourceFile } = LanguageLocaleUtils;
const getText = getLocaleResourceFile('ai/components/SuperChat/locales', 'SuperChat');

function IconImage({ src, alt, marginRight }) {
    return (
        <Image
            disableLazyLoad={true}
            alt={alt || getText('title')}
            src={src}
            marginRight={marginRight}
        />
    );
}

export default wrapFunctionalComponent(IconImage, 'IconImage');
